<template>
  <div class="companyInvitationBox">
    <Form ref="searchForm" :label-width="120" :model="formCustom" inline>
      <Form-item label="姓名：" prop="adminNikeName">
        <Input v-model="formCustom.adminNikeName" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="手机号：" prop="adminTelephone">
        <Input v-model="formCustom.adminTelephone" :maxlength="50" clearable placeholder="请输入"
               style="width: 200px"></Input>
      </Form-item>
      <Form-item label="状态：" prop="approvalStatus">
        <Select v-model="formCustom.approvalStatus" clearable filterable placeholder="请选择" style="width: 200px">
          <Option value="5">已邀请</Option>
          <Option value="6">同意邀请</Option>
          <Option value="7">拒绝邀请</Option>
        </Select>
      </Form-item>
      <Form-item>
        <Button type="primary" @click="handleSearch">查询</Button>
        <Button class="iviewButton" @click="handleReset('searchForm')">重置</Button>
      </Form-item>
    </Form>
    <div style="margin-bottom: 20px">
      <Button type="primary" @click="inviteDialogShow()">邀请</Button>
    </div>
    <div>
      <Table :columns="companyInvitationColumns" :data="companyInvitationTableData" :loading="loading"
             aria-describedby="" aria-hidden="true" border>
        <template slot="approvalStatus" slot-scope="{ row }">
          <span>{{
              row.approvalStatus === 5 ? '已邀请' : row.approvalStatus === 6 ? '同意邀请' : row.approvalStatus === 7 ? '拒绝邀请' : '其他'
            }}</span>
        </template>
        <template slot="action" slot-scope="{ row }">
          <Button v-if="row.approvalStatus !== 6" size="small" type="text" @click="remove(row.companyInvitationId)">
            删除
          </Button>
        </template>
      </Table>
      <Page ref="pages" :current="page" :total="total" class="page_position" show-elevator show-sizer show-total
            @on-change="setCurrent" @on-page-size-change="setPage"></Page>
    </div>
    <el-dialog :visible.sync="inviteDialogVisible" title="邀请用户" width="30%">
      <Form ref="inviteForm" :label-width="120" :model="formCustom">
        <Form-item label="手机号：">
          <Input v-model="adminTelephone" :maxlength="11" clearable placeholder="请输入手机号"
                 style="width: 240px"></Input>
        </Form-item>
        <Form-item label="关联角色：" prop="roleId">
          <Select v-model="formCustom.roleId" clearable filterable style="width: 240px" @on-change="changeRole">
            <Option v-for="item in roleList" :value="item.roleId">{{ item.roleName }}</Option>
          </Select>
        </Form-item>
        <Form-item>
          <Button class="next" type="primary" @click="invite">提交</Button>
        </Form-item>
      </Form>
    </el-dialog>
  </div>
</template>

<script>
import permissionList from '@/libs/handlePermission.ts'
import {companyInvitationDelete, companyInvitationInvite, companyInvitationPage} from "@/api/organization";
import {roleList} from "@/api/authority";

export default {
  name: 'companyInvitation',
  data() {
    return {
      total: 0,
      page: 1,
      size: 10,
      pageSize: 10,
      loading: false, // 表格等待
      btnList: [],
      formCustom: {
        adminNikeName: '',
        adminTelephone: '',
        approvalStatus: ''
      },
      companyInvitationColumns: [
        {type: 'index', title: '序号', align: 'center'},
        {title: '账号编码', key: 'adminCode', align: 'center'},
        {title: '姓名', key: 'adminNikeName', align: 'center'},
        {title: '手机号', key: 'adminTelephone', align: 'center'},
        {title: '邀请时间', key: 'createTime', align: 'center'},
        {title: '关联角色', key: 'roleName', align: 'center'},
        {title: '状态', key: 'approvalStatus', slot: 'approvalStatus', align: 'center'},
        {title: '操作', slot: 'action', align: 'center', fixed: 'right'}
      ],
      companyInvitationTableData: [], // 表格数据
      inviteDialogVisible: false,
      adminTelephone: '',
      roleId: '',
      roleList: [] // 关联角色下拉框
    }
  },
  mounted() {
    const list = JSON.parse(localStorage.getItem('routerList'))
    // eslint-disable-next-line new-cap
    this.btnList = new permissionList(list, this.$route.path).getList()
    this.init()
  },
  methods: {
    // 初始化
    init() {
      this.loading = true
      companyInvitationPage({
        current: 1,
        size: 10,
        invitationType: 2
      }).then((res) => {
        this.changeData(res)
      })
      roleList({
        organizationType: 1
      }).then((res) => {
        this.roleList = res.data.data
      })
    },
    // 查询
    handleSearch() {
      const data = {
        ...this.formCustom
      };
      companyInvitationPage({
        current: 1,
        size: this.pageSize,
        invitationType: 2,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    // 调接口获取表格数据
    changeData(res) {
      this.total = res.data.data.total
      this.size = res.data.data.size
      this.companyInvitationTableData = res.data.data.records
      this.loading = false
    },
    // 重置
    handleReset(name) {
      this.$refs[name].resetFields()
      // 重置查询条件会再次查询
      this.handleSearch()
    },
    // 改变页码
    setCurrent(val) {
      const data = {
        ...this.formCustom
      };
      this.loading = true
      this.page = val
      companyInvitationPage({
        current: val,
        size: this.pageSize,
        invitationType: 2,
        ...data
      }).then((res) => {
        this.changeData(res)
      })
    },
    // 改变每页条数
    setPage(val) {
      const data = {
        ...this.formCustom
      };
      this.loading = true
      this.pageSize = val
      companyInvitationPage({
        current: 1,
        size: this.pageSize,
        invitationType: 2,
        ...data
      }).then((res) => {
        this.changeData(res)
        this.$refs['pages'].currentPage = 1 // 分页变成第一页
      })
    },
    inviteDialogShow() {
      this.inviteDialogVisible = true
    },
    invite() {
      if (this.adminTelephone === null || this.adminTelephone === '') {
        this.$Message.warning('请填写邀请用户！')
        return;
      }
      if (this.roleId === null || this.roleId === '') {
        this.$Message.warning('请选择关联角色！')
        return;
      }

      companyInvitationInvite({
        adminTelephone: this.adminTelephone,
        roleId: this.roleId
      }).then((response) => {
        if (response.data.success === false) {
          this.$Message.error(response.data.msg)
        } else {
          this.$Message.success(response.data.msg)
          this.init()
        }
      })
      this.inviteDialogVisible = false
    },
    // 删除
    remove(id) {
      this.$Modal.confirm({
        title: '确认删除？',
        onOk: () => {
          companyInvitationDelete(id).then((res) => {
            this.$Message.success(res.data.msg)
            this.init()
          }).catch(() => {
            this.$Message.error('删除失败')
          })
        },
        onCancel: () => {
          this.$Message.info('已取消删除')
        }
      })
    },
    // 获取下拉框关联角色数据
    changeRole(val) {
      this.roleId = val
    }
  }
}
</script>
<style lang="less">
.next {
  border-radius: 4px;
  background-color: rgba(0, 123, 211, 1);
  color: rgba(255, 255, 255, 1);
  font-size: 18px;
  height: 50px;
  border-color: #3A62D7;
  width: 80%
}
</style>
